import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#C8D8FF'}
      d="M5.62 27.94c-2.86 0-5.1-2.18-5.1-4.96V8.059c0-2.86 2.24-5.1 5.1-5.1h1.81v-.98c0-.68.42-1.1 1.1-1.1.68 0 1.1.42 1.1 1.1v.98h8.86v-.98c0-.68.42-1.1 1.1-1.1.68 0 1.1.42 1.1 1.1v.98h1.81c2.86 0 5.11 2.2 5.24 5.12v14.77c0 2.81-2.29 5.1-5.1 5.1h-17l-.02-.01Zm0-22.801c-1.61 0-2.91 1.31-2.91 2.91v14.78c0 1.61 1.31 2.91 2.91 2.91h16.86c1.61 0 2.91-1.31 2.91-2.91V8.05c0-1.61-1.31-2.91-2.91-2.91h-1.81v.98c0 .68-.42 1.1-1.1 1.1-.68 0-1.1-.42-1.1-1.1v-.98H9.61v.98c0 .68-.42 1.1-1.1 1.1-.68 0-1.1-.42-1.1-1.1v-.98H5.6h.02Z"
    />
    <Path
      fill={props.fill || '#C8D8FF'}
      d="M7.97 14.4c-.68 0-1.1-.421-1.1-1.101 0-.68.42-1.1 1.1-1.1h12.31c.68 0 1.1.42 1.1 1.1 0 .68-.42 1.1-1.1 1.1H7.97ZM7.97 20.49c-.68 0-1.1-.421-1.1-1.101 0-.68.42-1.1 1.1-1.1h8.16c.68 0 1.1.42 1.1 1.1 0 .68-.42 1.1-1.1 1.1H7.97Z"
    />
  </Svg>
);
export default SvgComponent;
